import {Base} from "@/api/Base"

export class PolicyDeleteExtraOverrideTemplate extends Base {
    path = "policy/deleteExtraOverrideTemplate"
}